import * as _ from 'underscore';
import * as appTheme from './appTheme';

export function deserializeWorkspace(data, glob) {
    if (data == null) {
        return null;
    }

    if (typeof data === 'string') {
        if (data === 'null') {
            // OE: may occur due to very old Taras's BUG
            return null;
        }
        data = JSON.parse(data);
    }

    data.theme = appTheme.fillMapObj(data.theme, glob);

    data.widgets = _.map(data.widgets, (obj: any) => {
        return deserializeWidget(obj, glob);
    });

    data.widgetsLocal = {};

    return data;
}

function deserializeWidget(obj, glob) {
    obj.values = _.mapObject(obj.values, (val, key) => {
        if (val.theme != null) {
            val.theme = appTheme.fillMapObj(val.theme, glob);
        }

        return val;
    });

    var obj_type = obj.type;
    if (obj.values[obj_type] != null) {
        var childWidgets = obj.values[obj_type].widgets;
        obj.values[obj_type].widgets = _.map(childWidgets, (w) => {
            return deserializeWidget(w, glob);
        });
    }

    return obj;
}
